/*
 * File: catalog-upload.component.ts                                           *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 16th February 2022 13:06:31                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:43:04                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, OnInit } from '@angular/core';
import { CatalogService } from '../../../services/catalog.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CatalogDb } from '@nousmedis/cc-types';

export interface ExportSummary {
  name: string;
  totalFascicles: number;
  totalPages: number;
  totalCells: number;
  totalProducts: number;
}

@Component({
  selector: 'app-catalog-upload',
  templateUrl: './catalog-upload.component.html',
  styleUrls: ['./catalog-upload.component.scss']
})
export class CatalogUploadComponent implements OnInit {
  loaded: boolean = false;
  noExportCredentials: boolean = false;
  errorUploading: boolean = false;
  uploaded: boolean = false;
  uploading: boolean = false;
  idCatalog: string;
  checkedData: boolean = false;
  uploadErrors: boolean = false;
  errorMessages: string[] = [];
  dataSummary: ExportSummary | undefined;

  exportCrententials: any = {
    token: '',
    url: '',
  };

  hasFascicles: boolean = false;

  private catalog: CatalogDb | undefined;

  constructor(private catalogService: CatalogService, private dialogData: DynamicDialogConfig, private dialogRef: DynamicDialogRef) {
    this.idCatalog = this.dialogData.data.id;
  }

  ngOnInit(): void {
    this.catalogService.getCatalog(this.idCatalog).subscribe((data: CatalogDb) => {
      if (data && data.exportCredentials) {
        this.catalog = data;
        this.exportCrententials.token = data.exportCredentials.token;
        this.exportCrententials.url = data.exportCredentials.url;
        this.loaded = true;
        this.hasFascicles = data.fascicles && data.fascicles.length > 0;
      } else {
        this.loaded = false;
        this.noExportCredentials = true;
      }
    });
  }

  private buildSummary(): ExportSummary {
    const fascicles = this.catalog?.fascicles ?? [];
    let totalPages = 0;
    let totalCells = 0;
    let totalProducts = 0;

    for (const fascicle of fascicles) {
      const pages = (fascicle as any).pages ?? [];
      totalPages += pages.length;
      for (const page of pages) {
        const cells = page.cells ?? [];
        totalCells += cells.length;
        totalProducts += cells.filter((c: any) => c.product != null).length;
      }
    }

    return {
      name: this.catalog?.name ?? '',
      totalFascicles: fascicles.length,
      totalPages,
      totalCells,
      totalProducts,
    };
  }

  async export() {
    if (!this.hasFascicles) {
      this.errorUploading = true;
      return;
    }

    try {
      this.uploading = true;
      this.uploaded = false;
      this.errorUploading = false;

      await this.catalogService.exportToSW(this.idCatalog);

      this.dataSummary = this.buildSummary();
      this.uploading = false;
      this.uploaded = true;
    } catch (e) {
      console.error('Error exporting catalog to SW', e);
      this.uploading = false;
      this.uploaded = false;
      this.errorUploading = true;
    }
  }
  // checkUpload() {
  //   this.loading = true;
  //   this.catalogService.checkUploadToSs(this.idCatalog).subscribe(data => {
  //     this.checkData = this.dataToTable(data);
  //     this.loading = false;
  //     this.checkedData = true;

  //   });
  // }

  // dataToTable(data: any) {
  //   // let table = [];
  //   // for (let key in data) {
  //   //   table.push({ key: "SALESLAYER." + key.toUpperCase(), value: data[key] });
  //   // }
  //   // return table;
  // }

  // upload() {
  //   // this.checkData = undefined;
  //   this.loading = true;
  //   this.catalogService.uploadToSs(this.idCatalog).subscribe(data => {
  //     this.checkErrors(data);
  //     this.uploaded = true;
  //     this.loading = false;
  //     
  //   });
  // }

  // checkErrors(data: any) {
  //   if (data && data.input_response && data.input_response.errors) {
  //     if (Array.isArray(data.input_response.errors)) {
  //       this.uploadErrors = true;
  //       for (let error of data.input_response.errors) {
  //         this.errorMessages.push(error);
  //       }
  //     }
  //     else {
  //       this.errorMessages.push(data.input_response.errors);
  //     }
  //   }
  //   else {
  //     this.uploadErrors = false;
  //   }

  // }

  close() {
    this.dialogRef.close();
  }
}
